import type Parse from 'parse';

import { LabelConfig } from '@telespot/domain';
import { ParseMapper } from '../../parse.mapper';
import { ObjectTopology } from '../../parse.topology';
import { MethodTypeTopology } from './parse-method-type.mapper';

export enum LabelConfigTopology {
  TABLE = 'LabelConfig',
  METHOD_TYPE = 'methodType',
  COLOR = 'color',
  LABEL = 'label',
}

export class ParseLabelConfigMapper extends ParseMapper {
  public toDomain(parseObject: Parse.Object): LabelConfig {
    return new LabelConfig({
      id: parseObject.id,
      color: parseObject.get(LabelConfigTopology.COLOR),
      label: parseObject.get(LabelConfigTopology.LABEL),
      methodTypeId: parseObject.get(LabelConfigTopology.METHOD_TYPE)?.id,
      createdAt: parseObject.createdAt,
      updatedAt: parseObject.updatedAt,
    });
  }

  public fromDomain(labelConfig: LabelConfig): Parse.Object {
    const methodType = this.subclasses
      .getSubclass(MethodTypeTopology.TABLE)
      .createWithoutData(labelConfig.methodTypeId);

    const parseObject = this.parse.Object.fromJSON(
      {
        className: LabelConfigTopology.TABLE,
        [ObjectTopology.ID]: labelConfig.id,
        [ObjectTopology.CREATED_AT]: labelConfig.createdAt,
        [ObjectTopology.UPDATED_AT]: labelConfig.updatedAt,
      },
      false
    );

    parseObject.set({
      [LabelConfigTopology.METHOD_TYPE]: methodType,
      [LabelConfigTopology.COLOR]: labelConfig.color,
      [LabelConfigTopology.LABEL]: labelConfig.label,
    });

    return parseObject;
  }
}
